import React from "react";
import { RiDoubleQuotesR } from "react-icons/ri";
import { BsPlayCircleFill } from "react-icons/bs";
import { getAssets } from "@unisearch/helpers";
import styles from "./testimonial_card.module.scss";

const TestimonialCard = () => {
  return (
    <div className={`${styles.test_item_wrapper} test_item_wrapper`}>
      <div className={`${styles.test_item} test_item`}>
        <div className={`${styles.test_quote_icon} test_quote_icon`}>
          <RiDoubleQuotesR />
        </div>
        <div className={`${styles.test_video_icon} test_video_icon`}>
          <BsPlayCircleFill />
        </div>
        <p className={`${styles.test_text} test_text`}>
          From the very beginning we are committed to our learners and in return
          they trust us. We’ve been updating our library and adding courses on a
          regular basis.
        </p>

        <div className={`${styles.test_person_wrapper} test_person_wrapper`}>
          <div className={`${styles.test_avatar_wrapper} test_avatar_wrapper`}>
            <img src={getAssets("assets/images/avatar.png")} alt="avatar" />
          </div>
          <div
            className={`${styles.test_person_info_wrapper} test_person_info_wrapper`}
          >
            <div className={`${styles.test_name} test_name`}>
              Malisha Wilson
            </div>
            <p className={`${styles.test_designation} test_designation`}>
              Kings Collage London
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
